import React, { useEffect, useState } from "react";
import { Layout, Card, Table, Button, Space, Input } from "antd";
import { ToolActivityDlg } from "./ToolActivityDlg";
import { EditOutlined } from "@ant-design/icons";
import { GradeRange } from "../../components/GradeRange";
import { observer } from "mobx-react";
import { Store } from "../../store/Store";

export const EngToolActivities = observer(() => {
  const store = Store.engTool.activities;
  const [model, setModel] = useState({ id: null });
  const [showDlg, setShowDlg] = useState(false);

  useEffect(() => {
    store.refresh();
  }, []);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Activity Type",
      dataIndex: "activityType",
      width: 160,
      key: "type",
    },
    {
      title: "Activity Name",
      dataIndex: "activityName",
      width: 200,
      key: "name",
    },
    {
      title: "Grade Range",
      dataIndex: "grades",
      key: "grades",
      width: 100,
      render: (v) => <GradeRange grades={v} />,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },

    {
      title: "Status",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "",
      key: "opt",
      render: (t, r) => <EditOutlined onClick={() => onEdit(r)} />,
    },
  ];

  const onEdit = (m) => {
    setModel(m);
    setShowDlg(true);
  };

  return (
    <Layout.Content className="padding24">
      <Card
        size="small"
        title="Title Description"
        bodyStyle={{ padding: 0 }}
        extra={
          <Space>
            <Button onClick={() => store.refresh()}>Refresh</Button>
            <Button onClick={() => onEdit({})}>Add</Button>
            <Input.Search
              allowClear
              value={store.keyword}
              onChange={(e) => (store.keyword = e.target.value)}
            ></Input.Search>
          </Space>
        }
      >
        <Table size="small" loading={store.loading} rowKey="id" columns={columns} dataSource={store.activities} />
        {showDlg && (
          <ToolActivityDlg
            model={model}
            onClose={() => {
              setShowDlg(false);
              store.refresh();
            }}
          />
        )}
      </Card>
    </Layout.Content>
  );
});
